import { useNavigate, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { ITableContainerProps } from '../../../types/Interfaces';
import { IVariantData } from '../types/interfaces';

const VariantsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IVariantData[]>) => {
  const { t, i18n } = useTranslation();
  const { id, modelId } = useParams();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['variants.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head equal_cols ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className={`item equal_cols ${hasEditPermission && 'clickable'} vehicles`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/vehicle-models/${id}/model-variants/${modelId}/variant-edit/${item.id}`, navigate);
                }}
              >
                <div className="column flex-grow-2">{item?.display_name_translation?.[i18n.language] || '-'}</div>
                <div className="column">{item?.code || '-'}</div>
                {/* <div className="column">{item?.transmission?.name || '-'}</div> */}
                <div className="column">{item?.model_year || '-'}</div>
                <div className="column">{item?.hidden ? t('yes') : t('no')}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/vehicle-models/${id}/model-variants/${modelId}/variant-edit/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default VariantsTableContainer;
